'use client';

import { useEffect } from 'react';

import { Button, Container } from '@endaoment-frontend/design-system';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('Blog error:', error);
  }, [error]);

  return (
    <Container width='narrow' className='py-section text-center'>
      <h1 className='title-2'>Something went wrong.</h1>
      <p className='paragraph-lg mt-4 text-muted'>We hit an error loading this page.</p>
      <Button onClick={reset} className='mt-8'>
        Try again
      </Button>
    </Container>
  );
}
